import { ChartPie } from "lucide-react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const data = [
  { name: "Desktop", value: 400 },
  { name: "Mobile", value: 300 },
  { name: "Tablet", value: 300 },
  { name: "Others", value: 200 },
];

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042"];

const total = data.reduce((acc, item) => acc + item.value, 0);

export default function SourceWiseLeadScore() {
  return (
    <div className="w-full max-w-md bg-white p-1 h-auto">
      <div className="flex items-center gap-3">
        <div className="bg-orange-400 p-2 rounded-md">
          <ChartPie className="w-5 h-5 text-white" />
        </div>
        <h1 className="text-[14px]">Lead Source Score</h1>
      </div>

      <div style={{ width: "100%", height: 200 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="flex flex-col justify-center mt-2 gap-2">
        {data.map(({ name, value }, idx) => (
          <div key={idx} className="flex items-center gap-4 px-5 justify-around">
            <div className="flex items-center gap-2">
              <div
                className="rounded-full w-3 h-3"
                style={{ backgroundColor: COLORS[idx] }}
              ></div>
              <span className="text-sm text-gray-500">{name}</span>
            </div>
            <span className="text-sm font-[500]">
              {((value / total) * 100).toFixed(2)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
